module.exports = __webpack_public_path__ + "static/media/onboarding-creators-min.958027d0.jpg";